import { extendTheme } from "@chakra-ui/react"

const fonts = {
  en: 'Silkscreen, sans-serif',
  ja: '"DotGothic16", Silkscreen, sans-serif',
  zhTW: '"Noto Sans TC", Silkscreen, sans-serif',
  th: '"Kanit", "Sarabun", Silkscreen, sans-serif'
};

export const theme = extendTheme({
  colors: {
    opensea: {
      500: '#0978BA'
    },
    linegreen: {
      500: '#06C755'
    }
  },
  styles: {
    global: {
      'html, body': {
        background: '#F5EFEA',
      },
      'body': {
        fontFamily: fonts.en,
      },
      'body:lang(ja), body:lang(ja-JP)': {
        fontFamily: fonts.ja,
      },
      'body:lang(zh-TW)': {
        fontFamily: fonts.zhTW,
      },
      'body:lang(th)': {
        fontFamily: fonts.th,
      },
      // Chakra UI 컴포넌트들의 폰트를 강제 상속
      '.chakra-text, .chakra-heading, .chakra-button, .chakra-menu__menu-item, [class*="chakra"]': {
        fontFamily: 'inherit !important',
      },
      a: {
        color: 'teal.500',
        _hover: {
          textDecoration: 'underline',
        },
      },
    },
  },
  components: {
    Text: {
      baseStyle: {
        fontFamily: 'inherit',
      },
    },
    Heading: {
      baseStyle: {
        fontFamily: 'inherit',
      },
    },
    Button: {
      baseStyle: {
        fontFamily: 'inherit',
      },
    },
    Menu: {
      baseStyle: {
        fontFamily: 'inherit',
      },
    },
  },
  fonts: {
    heading: 'inherit',
    body: 'inherit',
  },
});

export const retroTheme = {
  colors: {
    accentColor: 'hsl(335 50% 44%)',
    accentColorForeground: 'hsl(0, 0%, 100%)',
    actionButtonBorder: 'hsl(0, 0%, 100%)',
    actionButtonBorderMobile: 'hsl(0, 0%, 100%)',
    actionButtonSecondaryBackground: 'hsl(0, 0%, 100%)',
    closeButton: 'hsl(180, 3%, 39%)',
    closeButtonBackground: 'hsl(0, 0%, 94%)',
    connectButtonBackground: 'hsl(0, 0%, 100%)',
    connectButtonBackgroundError: 'hsl(360,100%,64%)',
    connectButtonInnerBackground: 'hsl(0, 0%, 95%)',
    connectButtonText: '#222',
    connectButtonTextError: 'hsl(0,0%,100%)',
    error: 'hsl(0,0%,100%)',
    generalBorder: 'hsl(180, 0%, 94%)',
    generalBorderDim: 'rgba(0, 0, 0, 0.03)',
    menuItemBackground: 'hsl(180, 3%, 92%)',
    modalBackdrop: 'rgba(0, 0, 0, 0.5)',
    modalBackground: 'hsl(0, 0%, 100%)',
    modalBorder: 'hsl(0, 0%, 100%)',
    modalText: 'hsl(213, 11%, 16%)',
    modalTextDim: 'rgba(60, 66, 66, 0.3)',
    modalTextSecondary: 'hsl(200, 1%, 55%)',
    profileAction: 'hsl(0, 0%, 100%)',
    profileActionHover: 'hsl(0, 0%, 98%)',
    profileForeground: 'hsl(0, 0%, 96%)',
    selectedOptionBorder: 'hsl(335 50% 44%)',
    downloadBottomCardBackground: 'linear-gradient(126deg, rgba(255, 255, 255, 0) 9.49%, rgba(171, 171, 171, 0.04) 71.04%), #FFFFFF',
    downloadTopCardBackground: 'linear-gradient(126deg, rgba(171, 171, 171, 0.2) 9.49%, rgba(255, 255, 255, 0) 71.04%), #FFFFFF',
    connectionIndicator: 'hsl(107, 100%, 44%)',
    standby: 'hsl(47, 100%, 63%)',
  },
  radii: {
    actionButton: '12px',
    connectButton: '6px',
    menuButton: '6px',
    modal: '12px',
    modalMobile: '12px',
  },
  shadows: {
    connectButton: '4px 4px 4px rgba(43, 43, 47, 0.25)',
    dialog: '4px 4px 4px rgba(43, 43, 47, 0.25)',
    profileDetailsAction: '0px 2px 6px rgba(37, 41, 46, 0.04)',
    selectedOption: '0px 2px 6px rgba(0, 0, 0, 0.24)',
    selectedWallet: '0px 2px 6px rgba(0, 0, 0, 0.12)',
    walletLogo: '0px 2px 16px rgba(0, 0, 0, 0.16)',
  },
  blurs: {
    modalOverlay: 'blur(0px)',
  },
  fonts: {
    body: 'inherit',
  },
};

const themes = { theme, retroTheme };
export default themes;